import React, { createContext, useState, useContext, ReactNode } from "react";

type SortDrawerContextType = {
  isSortDrawerOpen: boolean | string;
  setIsSortDrawerOpen: React.Dispatch<React.SetStateAction<boolean | string>>;
};

const SortDrawerContext = createContext<SortDrawerContextType | undefined>(undefined);

export const SortDrawerProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isSortDrawerOpen, setIsSortDrawerOpen] = useState<boolean | string>(false);

  return (
    <SortDrawerContext.Provider value={{ isSortDrawerOpen, setIsSortDrawerOpen }}>
      {children}
    </SortDrawerContext.Provider>
  );
};

export const useSortDrawer = () => {
  const context = useContext(SortDrawerContext);
  if (context === undefined) {
    throw new Error("useSortDrawer must be used within a SortDrawerProvider");
  }
  return context;
};
